import React, { useEffect, useState , forwardRef, useImperativeHandle } from 'react';
import html2pdf from 'html2pdf.js';
import '../App.css';
import { BASE_URL } from "../utils/config";
import FutureBuyReport from '../components/futurebuyReport';
import IndexIntradayBuyReport from '../components/index-intradaybuyReport'
import IndexIntradaySellReport from '../components/index-intradaysellReport'
import FutureSellReport from '../components/futuresellReport';
import OptionsPutReport from '../components/optionPutReport';
import NKBPutReport from '../components/nkbPutReport';
import OptionCallReport from '../components/optionCallReport';
import NKBCallReport from '../components/nkbCallReport';
import DeliveryReport from '../components/DeliveryReport';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useNavigate } from "react-router-dom";
import Loading from '../components/loading'

const Report = forwardRef((props, ref) => {
   
    const navigate = useNavigate();
    const { setEventChange, onSuccessSubmit, isMCX } = props
    const checked = props.reportChecked
    const optionChecked =  props.eventType === 'IndexIntraday' ? props.reportOptionChecked : null;
    const IntraDaychecked = props.eventType === 'Options' ? false : props.eventType === 'IntraDay' ? props.IntraDayChecked : null;
    const SecondTarget = props.eventType === 'IntraDay' ? props.SecondTarget : null;
    const FreeChecked = (props.eventType === 'Options' || props.eventType === 'IntraDay' || props.eventType === 'Delivery') ? props.FreeChecked : null;
    const eventType = props.eventType;
    const reportDate = props.reportDate;
    const imageUrl = props.imageUrl;
    const imageBuffer = props.imageBuffer;
    const futureSectionState = props.eventType === 'Future' ? props.SectionState : {};
    const indexIntradaySectionState = props.eventType === 'IndexIntraday' ? props.SectionState : {};
    const optionSectionState = props.eventType === 'Options' ? props.SectionState : {};
    const NKBSectionState = props.eventType === 'NKB' ? props.SectionState : {};
    console.log("nkb",NKBSectionState)
    const deliverySectionState = props.eventType === 'Delivery' || props.eventType === 'HNI' ? props.SectionState : {};
    const stockLossRecord = props.stockLossRecord;
    const selectedExpiryRecord = props.selectedExpiryRecord;
    const selectedStockRecord = props.selectedStockRecord;
    const deliveryIntraDayChecked = props.eventType === 'Delivery' ? props.DeliveryIntraDayChecked : null
    const [ReportData, setReportData] = useState({});
    const [DataFeedRecord, setDataFeedRecord] = useState({});
    const [optionReportData, setOptionReportData] = useState({});
    const [loginuser, setLoginuser] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSaveReportSuccessful, setIsSaveReportSuccessful] = useState(false);
    const [ReportError, setReportError] = useState(false)
    const [ReportSuccess, setReportSuccess] = useState(false)
    const [dialogBox, setDialogBox] = useState(false);
    const [reportCreated, setReportCreated] = useState(false);
    const [ReportAlreadySuccess, setReportAlreadySuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errormessage, setErrorMessage] = useState(false);

    let count = 0;
    let formattedDate = '';
    let formattedTime = '';
    useEffect(() => {
        if (count === 0) {
            const currentDate = new Date();

            // Get date components
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
            const day = currentDate.getDate();

            // Get time components
            const hours = currentDate.getHours();
            const minutes = currentDate.getMinutes();
            const seconds = currentDate.getSeconds();

            // Format date and time
            formattedDate = `${year}/${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}`;

            // console.log("formatesd date", formattedDate)
            formattedTime = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;

            // console.log("formattedTime", formattedTime)

            let loginuser = JSON.parse(localStorage.getItem("loginData"));
            setLoginuser(loginuser);
           
            count += 1;
        }

    }, [])

 
// handle calling form another child component
    useImperativeHandle(ref, () => ({
        submitreport,
        resetReportAlreadySuccess: () => setReportCreated(false),
    }));

    // download pdf for future buy report
    const futurebuydownloadPDF = (elementId, formattedDate, formattedTime) => {
        try {
            setTimeout(() => {
                const element = document.getElementById(elementId);
                if (element) {
                    const pdfOptions = {
                        margin: 5,
                        filename: `future_buy_report_${formattedDate}.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                    };

                    html2pdf(element, pdfOptions);
                } else {
                    console.error(`Element with ID ${elementId} not found.`);
                    alert('Failed to generate PDF. Element not found.');
                }
            }, 1000);
        } catch (error) {
            console.error('Error generating PDF:', error);
            // alert('An error occurred while generating the PDF. Please try again.');
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('An error occurred while generating the PDF. Please try again.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };

    // download pdf for future sell report
    const futureselldownloadPDF = (elementId, formattedDate, formattedTime) => {
       try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `future_sell_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
    };

    // download pdf for option call report
    const optioncalldownloadPDF = (elementId, formattedDate, formattedTime) => {
       try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `option_call_report${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
    };

// download pdf for option put report
    const optionputdownloadPDF = (elementId, formattedDate, formattedTime) => {
       try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `option_put_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
     } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
    };

    const NKBputdownloadPDF = (elementId, formattedDate, formattedTime) => {
       try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `option_put_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
     } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
    };


    // download pdf for index intraday buy report
    const indexIntradayBUYdownloadPDF = (elementId, formattedDate, formattedTime) => {
        try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `indexIntraday_BUY_report${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
    };

// download pdf for index intraday sell report
    const indexIntradaySELLdownloadPDF = (elementId, formattedDate, formattedTime) => {
        try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `indexIntraday_SELL_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
     } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
    };

    // download pdf for  delivery and Hni report
    const deliveryreportdownloadPDF = (elementId, formattedDate, formattedTime) => {
      try{
        setTimeout(() => {
            const element = document.getElementById(elementId);
            // console.log("event functuon ", element)

            if (element) {
                const pdfOptions = {
                    margin: 5,
                    filename: `delivery_report_${formattedDate}.pdf`,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 2 },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                };

                html2pdf(element, pdfOptions);
            }
        }, 1000)
    } catch (error) {
        console.error('Error generating PDF:', error);
        // alert('An error occurred while generating the PDF. Please try again.');
        setDialogBox(true);
        setShowError(true);
        setErrorMessage('An error occurred while generating the PDF. Please try again.');
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    } 
    };


    
// handle Send to telegram api for future ,option,delivery,hni and other
    const sendtotelegram = (isMCX) => {
        try{
        console.log("isMCX", isMCX);
        console.log("Free", FreeChecked);

        if (!ReportData || Object.keys(ReportData).length === 0) {
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Report data is missing. Please generate the report before sending.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        setLoading(true);
        let data;
        if (eventType === 'Future') {
            data = JSON.stringify({DataRecordID:DataFeedRecord, ReportData: ReportData, commentery: checked === true ? 'YES' : 'NO', isMCX: isMCX });
        } else if (eventType === 'Options') {
            data = JSON.stringify({DataRecordID:DataFeedRecord, ReportData: ReportData, commentery: checked === true ? 'YES' : 'NO', intraday: isMCX, Free: FreeChecked });
        } else if (eventType === 'IntraDay') {
            data = JSON.stringify({DataRecordID:DataFeedRecord, ReportData: ReportData, commentery: checked === true ? 'YES' : 'NO', intraday: isMCX, secondTagert: SecondTarget, Free: FreeChecked });
        } else if (eventType === 'Delivery') {
            data = JSON.stringify({DataRecordID:DataFeedRecord, ReportData: ReportData, commentery: checked === true ? 'YES' : 'NO', deliveryIntraDay: isMCX, Free: FreeChecked });
        } else {
            data = JSON.stringify({DataRecordID:DataFeedRecord, ReportData: ReportData, commentery: checked === true ? 'YES' : 'NO' });
        }

        fetch(`${BASE_URL}/sendtotelegram`, {
            method: 'POST',
            body: data,
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${loginuser.token}`
            },
        }).then(response => response.json())
            .then(res => {
            console.log(res);
            if (res.success === true) {
                setReportCreated(false);
                setLoading(false);
                setEventChange(eventType);
            } else if (res.status === 403 || res.status === 401) {
                setTimeout(() => {
                localStorage.clear();
                navigate('/login');
                }, 3000);
            } else {
                setLoading(false);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${res.message}`);
                setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
                }, 2000);
            }
            })
            .catch(error => {
            setLoading(false);
            console.error('Error fetching data:', error);
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            });
        }catch(error){
            setLoading(false);
            
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };




    // send to telegram index intraday

    const sendtotelegramindexIntraday = (isMCX) => {
        try{
        console.log("isMCX", isMCX);
        console.log("Free", FreeChecked);

        if (!ReportData || Object.keys(ReportData).length === 0) {
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Report data is missing. Please generate the report before sending.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        setLoading(true);
        let data = JSON.stringify({ ReportData: ReportData, optionReportData:optionReportData, commentery: checked === true ? 'YES' : 'NO', isMCX: isMCX });

        fetch(`${BASE_URL}/sendtotelegramindexintraday`, {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loginuser.token}`
            },
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(false);
                    if (eventType === 'IndexIntraday') {
                        setLoading(false);
                        setEventChange('IndexIntraday');
                    }
                } else if (res.status === 403 || res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setShowError(true);
                    setErrorMessage(`Error: ${res.message}`);
                    setTimeout(() => {
                        setDialogBox(false);
                        setErrorMessage('');
                        setShowError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching data:', error);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${error.message}`);
                setTimeout(() => {
                    setDialogBox(false);
                    setErrorMessage('');
                    setShowError(false);
                }, 2000);
            });
        }catch(error){
            setLoading(false);
           
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };


//   handle Form Submit for all report types

    const submitreport = async (reportType, isMCX) => {

        console.log("reportcrewated", reportCreated)
        if (reportCreated === false) {
            setLoading(true)
            if (reportType === 'futureBuy') {

                futureBuyRepportSubmit(reportType, isMCX);

            }
            if (reportType === 'futureSell') {

                futureSellRepportSubmit(reportType, isMCX);

               
            }
            if (reportType === 'optionCall') {

                optionCallRepportSubmit(reportType);
               
            }
            if (reportType === 'optionPut') {


                optionPutRepportSubmit(reportType);
               
            }
            if (reportType === 'IndexIntradayBUY') {

                IndexIntradayBuyRepportSubmit(reportType);
                if(optionChecked){
                IndexIntradayBuyRepportOptionSubmit(reportType);
                }
               
            }
            if (reportType === 'IndexIntradaySELL') {
                IndexIntradaySellRepportSubmit(reportType);
                if(optionChecked){
                IndexIntradaySellRepportOptionSubmit(reportType);
                }
            }
            if (reportType === 'deliveryReport') {

                deliveryRepportSubmit(reportType);
                
            }
            if (reportType === 'hniReport') {

                HNIRepportSubmit(reportType);

            }
            if (reportType === 'NKBPut') {

                NKBPUTRepportSubmit(reportType);

            }
            if (reportType === 'NKBCall') {

                NKBCALLRepportSubmit(reportType);

            }
        }
        else {

            setReportAlreadySuccess(true);
            setDialogBox(true);

            setTimeout(() => {
                setDialogBox(false);
                setReportAlreadySuccess(false);
            }, 2500);

        }


    }


// handle report Create api for future buy 
    const futureBuyRepportSubmit = async (reportType, isMCX) => {
        try{
        console.log("stockLossRecord", stockLossRecord);

        // Check if all required values are present
        if (!futureSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {

            console.log("!futureSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id",futureSectionState, stockLossRecord, selectedExpiryRecord ,selectedStockRecord ,imageBuffer ,reportDate,loginuser,loginuser.user_id)
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
          
            }, 2000);
            return;
        }

        let data = JSON.stringify(futureSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('isMCX', isMCX);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
            'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
            console.log(res);
            if (res.success === true) {
                setReportCreated(true);
                onSuccessSubmit();
                setLoading(false);
                setReportData(res.data);
                setDataFeedRecord(res.Data_Feed_record)
                setIsSaveReportSuccessful(true);
                setDialogBox(true);
                setReportSuccess(true);
                setTimeout(() => {
                setDialogBox(false);
                setReportSuccess(false);
                }, 2000);
            } else if (res.status === 403) {
                setTimeout(() => {
                localStorage.clear();
                navigate('/login');
                }, 3000);
            } else if (res.status === 401) {
                setTimeout(() => {
                localStorage.clear();
                navigate('/login');
                }, 3000);
            } else {
                setLoading(false);
                setDialogBox(true);
                setReportError(true);
                setTimeout(() => {
                setDialogBox(false);
                setReportError(false);
                }, 2000);
            }
            })
            .catch(error => {
            setLoading(false);
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            console.error('Error failed to save report:', error);
            });
        }catch(error){
            setLoading(false);
          
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    }

// handle report Create api for future sell
    const futureSellRepportSubmit = async (reportType, isMCX) => {
        try{
        console.log("stockLossRecord", stockLossRecord)
        // console.log("base64 data of pdf", pdfBlob)
        console.log("report name", reportType)
        // console.log("image Buffer", imageBuffer)
        if (!futureSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
            }, 2000);
            return;
        }


        let data = JSON.stringify(futureSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        // console.log("data", data);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('isMCX', isMCX);

    

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {

                console.log(res);
                if (res.success === true) {
                    setReportCreated(true)
                    onSuccessSubmit();
                    setLoading(false)
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true)

                    setDialogBox(true)
                    setReportSuccess(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportSuccess(false)
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear()
                        navigate('/login')
                    }, 3000)
                }
                else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear()
                        navigate('/login')
                    }, 3000)
                }
                else {
                    setLoading(false)
                    setDialogBox(true)
                    setReportError(true)
                    setTimeout(() => {
                        setDialogBox(false)
                        setReportError(false)
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false)
                setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    }

// handle report Create api for option put report
    const optionCallRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("selectedExpiryRecord", selectedExpiryRecord);
        console.log("selectedStockRecord", selectedStockRecord);

        // Check if all required values are present
        if (!optionSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(optionSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', IntraDaychecked);
        formData.append('free', FreeChecked);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
                console.error('Error failed to save report:', error);
            });
    }catch(error){
        setDialogBox(true);
        setShowError(true);
        setErrorMessage(`Error: ${error.message}`);
        setTimeout(() => {
            setDialogBox(false);
            setErrorMessage('');
            setShowError(false);
        }, 2000);
    }
}

    // handle report Create api for option put report
    const optionPutRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("report name", reportType);

        // Check if all required values are present
        if (!optionSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(optionSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);
        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', IntraDaychecked);
        formData.append('free', FreeChecked);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);

                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };


   // handle report Create api for index intraday buy report
    const IndexIntradayBuyRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("selectedExpiryRecord", selectedExpiryRecord);
        console.log("selectedStockRecord", selectedStockRecord);
        console.log("image buffer from report submit,", imageBuffer);

        // Check if all required values are present
        if (!indexIntradaySectionState  || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(indexIntradaySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', IntraDaychecked);
        formData.append('free', FreeChecked);

        fetch(`${BASE_URL}/createIndexIntradayReport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${error.message}`);
                setTimeout(() => {
                    setDialogBox(false);
                    setErrorMessage('');
                    setShowError(false);
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };


    // handle report Create api for index intraday buy report
    const IndexIntradayBuyRepportOptionSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("selectedExpiryRecord", selectedExpiryRecord);
        console.log("selectedStockRecord", selectedStockRecord);
        console.log("image buffer from report submit,", imageBuffer);

        // Check if all required values are present
        if (!indexIntradaySectionState  || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(indexIntradaySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', IntraDaychecked);
        formData.append('free', FreeChecked);
        formData.append('optionChecked', optionChecked);

        fetch(`${BASE_URL}/createIndexIntradayOptionReport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setOptionReportData(res.data);
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                }
                 else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${error.message}`);
                setTimeout(() => {
                    setDialogBox(false);
                    setErrorMessage('');
                    setShowError(false);
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };



//   handle report Create api for index intraday sell report
    const IndexIntradaySellRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("selectedExpiryRecord", selectedExpiryRecord);
        console.log("selectedStockRecord", selectedStockRecord);

        // Check if all required values are present
        if (!indexIntradaySectionState  || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(indexIntradaySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', IntraDaychecked);
        formData.append('free', FreeChecked);

        fetch(`${BASE_URL}/createIndexIntradayReport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);

                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${error.message}`);
                setTimeout(() => {
                    setDialogBox(false);
                    setErrorMessage('');
                    setShowError(false);
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };


    //   handle report Create api for index intraday sell report
    const IndexIntradaySellRepportOptionSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("selectedExpiryRecord", selectedExpiryRecord);
        console.log("selectedStockRecord", selectedStockRecord);

        // Check if all required values are present
        if (!indexIntradaySectionState  || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(indexIntradaySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);
        formData.append('intraday', IntraDaychecked);
        formData.append('free', FreeChecked);
        formData.append('optionChecked', optionChecked);
        fetch(`${BASE_URL}/createIndexIntradayOptionReport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setOptionReportData(res.data);
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);

                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${error.message}`);
                setTimeout(() => {
                    setDialogBox(false);
                    setErrorMessage('');
                    setShowError(false);
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };


// handle report Create api for delivery and hni report
    const deliveryRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("report name", reportType);

        // Check if all required values are present
        if (!deliverySectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(deliverySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('deliveryIntraDay', deliveryIntraDayChecked);
        formData.append('free', FreeChecked);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true);

                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
                setShowError(true);
                setErrorMessage(`Error: ${error.message}`);
                setTimeout(() => {
                    setDialogBox(false);
                    setErrorMessage('');
                    setShowError(false);
                }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };

// handle report Create api for delivery and hni report
    const HNIRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("report name", reportType);

        // Check if all required values are present
        if (!deliverySectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(deliverySectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true);
                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };
// handle report Create api for NKB PUT and hni report
    const NKBPUTRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("report name", reportType);

        // Check if all required values are present
        if (!NKBSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(NKBSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true);
                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };



    // handle report Create api for NKB PUT and hni report
    const NKBCALLRepportSubmit = async (reportType) => {
        try{
        console.log("stockLossRecord", stockLossRecord);
        console.log("report name", reportType);

        // Check if all required values are present
        if (!NKBSectionState || !stockLossRecord || !selectedExpiryRecord || !selectedStockRecord || !imageBuffer || !reportDate || !loginuser || !loginuser.user_id) {
            setLoading(false)
            setDialogBox(true);
            setShowError(true);
            setErrorMessage('Missing required data to create the report. Please ensure all fields are filled.');
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
            return;
        }

        let data = JSON.stringify(NKBSectionState);
        let data1 = JSON.stringify(stockLossRecord);
        let data2 = JSON.stringify(selectedExpiryRecord);
        let data3 = JSON.stringify(selectedStockRecord);

        const formData = new FormData();
        formData.append('eventType', eventType);
        formData.append('ReportData', data);
        formData.append('ReportName', reportType);
        formData.append('imageData', imageBuffer);
        formData.append('reportDate', reportDate);
        formData.append('selectedExpiryRecord', data2);
        formData.append('selectedStockRecord', data3);
        formData.append('stockLossRecord', data1);
        formData.append('createdBy', loginuser.user_id);

        fetch(`${BASE_URL}/createreport`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
            },
            body: formData
        }).then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success === true) {
                    setReportCreated(true);
                    onSuccessSubmit();
                    setLoading(false);
                    setReportData(res.data);
                     setDataFeedRecord(res.Data_Feed_record)
                    setIsSaveReportSuccessful(true);
                    setDialogBox(true);
                    setReportSuccess(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportSuccess(false);
                    }, 2000);
                } else if (res.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else if (res.status === 401) {
                    setTimeout(() => {
                        localStorage.clear();
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoading(false);
                    setDialogBox(true);
                    setReportError(true);
                    setTimeout(() => {
                        setDialogBox(false);
                        setReportError(false);
                    }, 2000);
                }
            })
            .catch(error => {
                setLoading(false);
                setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
                console.error('Error failed to save report:', error);
            });
        }catch(error){
            setDialogBox(true);
            setShowError(true);
            setErrorMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setDialogBox(false);
                setErrorMessage('');
                setShowError(false);
            }, 2000);
        }
    };







    return (

        <>
            <div>
                <div className='ReportshowDiv'>
                    {loading ?
                        <div style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 2,
                        }}>
                            <Loading />
                        </div> : null}
                
                    {eventType === 'Future' && futureSectionState.futureReportType === 'BUY' ?
                        (<>
                            <div id="futureBuy" className='futureBuy'>
                                <FutureBuyReport reportData={futureSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} isMCX={isMCX} />
                            </div>

                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || futureSectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('futureBuy', isMCX) }} disabled={imageBuffer === '' || futureSectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} onClick={() => { futurebuydownloadPDF('futureBuy', formattedDate, formattedTime) }} disabled={!isSaveReportSuccessful || imageBuffer === ''}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} onClick={() => sendtotelegram(isMCX)} disabled={!isSaveReportSuccessful || imageBuffer === ''}>
                                    <i className="pi pi-send"></i> Send To Telegram</button>
                               
                            </div>
                           
                        </>) : null}



                    {eventType === 'Future' && futureSectionState.futureReportType === 'Sell' ?
                        (<>
                            <div id="futureSell" className='futureSell'>
                                <FutureSellReport reportData={futureSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} isMCX={isMCX} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || futureSectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('futureSell', isMCX) }} disabled={imageBuffer === '' || futureSectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { futureselldownloadPDF('futureSell', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => sendtotelegram(isMCX)}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>) : null}

                 
                    {eventType === 'IndexIntraday' && indexIntradaySectionState.optionReportType === 'BUY' ?
                        (<>


                            <div id="IndexIntradayBUY" className='optionCall'>
                                <IndexIntradayBuyReport reportData={indexIntradaySectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} IntraDayChecked={IntraDaychecked} />
                            </div>
                            <div className='report-btns'>
                                
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { indexIntradayBUYdownloadPDF('IndexIntradayBUY', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegramindexIntraday(IntraDaychecked) }}>
                                    <i className="pi pi-send"></i>Send Report</button>
                            </div>
                        </>) : null}



                    {eventType === 'IndexIntraday' && indexIntradaySectionState.optionReportType === 'SELL' ?
                        (<>
                            <div id="IndexIntradaySELL" className='optionPut'>
                                <IndexIntradaySellReport reportData={indexIntradaySectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} IntraDayChecked={IntraDaychecked} />
                            </div>
                            <div className='report-btns'>
                               
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { indexIntradaySELLdownloadPDF('IndexIntradaySELL', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegramindexIntraday(IntraDaychecked) }}>
                                    <i className="pi pi-send"></i>Send Report</button>
                            </div>
                        </>) : null}



                    {eventType === 'Options' && optionSectionState.optionReportType === 'CALL' ?
                        (<>
                            <div id="optionCall" className='optionCall'>
                                <OptionCallReport reportData={optionSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} IntraDayChecked={IntraDaychecked} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || optionSectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('optionCall') }} disabled={imageBuffer === '' || optionSectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { optioncalldownloadPDF('optionCall', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegram(IntraDaychecked) }}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>) : null}

                    {eventType === 'Options' && optionSectionState.optionReportType === 'PUT' ?
                        (<>
                            <div id="optionPut" className='optionPut'>
                                <OptionsPutReport reportData={optionSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} IntraDayChecked={IntraDaychecked} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || optionSectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('optionPut') }} disabled={imageBuffer === '' || optionSectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { optionputdownloadPDF('optionPut', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegram(IntraDaychecked) }}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>) : null}

                    {eventType === 'NKB' && NKBSectionState.nkbReportType === 'CALL' ?
                        (<>
                            <div id="NKBCall" className='NKBCall'>
                                <NKBCallReport reportData={NKBSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} IntraDayChecked={IntraDaychecked} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || NKBSectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('NKBCall') }} disabled={imageBuffer === '' || NKBSectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { optioncalldownloadPDF('optionCall', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegram(IntraDaychecked) }}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>) : null}

                    {eventType === 'NKB' && NKBSectionState.nkbReportType === 'PUT' ?
                        (<>
                            <div id="NKBPut" className='NKBPut'>
                                <NKBPutReport reportData={NKBSectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} IntraDayChecked={IntraDaychecked} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || NKBSectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('NKBPut') }} disabled={imageBuffer === '' || NKBSectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { NKBputdownloadPDF('NKBPut', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegram(IntraDaychecked) }}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>) : null}

                    {eventType === 'Delivery' && deliverySectionState.deliveryReportType === 'BUY' ?
                        (<>
                            <div id="deliveryReport" className='deliveryReport'>
                                <DeliveryReport reportData={deliverySectionState} imageData={imageUrl} reportDate={reportDate} reportType={deliveryIntraDayChecked ? 'IntraDay/BTST' : eventType} DeliveryIntraDayChecked={deliveryIntraDayChecked} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || deliverySectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('deliveryReport') }} disabled={imageBuffer === '' || deliverySectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { deliveryreportdownloadPDF('deliveryReport', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { sendtotelegram(deliveryIntraDayChecked) }}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>)
                        : null}

                    {eventType === 'HNI' && deliverySectionState.deliveryReportType === 'BUY' ?
                        (<>
                            <div id="hniReport" className='hniReport'>
                                <DeliveryReport reportData={deliverySectionState} imageData={imageUrl} reportDate={reportDate} reportType={eventType} />
                            </div>
                            <div className='report-btns'>
                                <button style={{ cursor: imageBuffer === '' || deliverySectionState.commentry === '' ? 'not-allowed' : 'pointer' }} type="button" onClick={() => { submitreport('hniReport') }} disabled={imageBuffer === '' || deliverySectionState.commentry === ''}>
                                    <i className="pi pi-save"></i>Save Report
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={() => { deliveryreportdownloadPDF('hniReport', formattedDate, formattedTime) }}>
                                    <i className="pi pi-download"></i>Download
                                </button>
                                <button type="button" style={{ cursor: !isSaveReportSuccessful || imageBuffer === '' ? 'not-allowed' : 'pointer' }} disabled={!isSaveReportSuccessful || imageBuffer === ''} onClick={sendtotelegram}>
                                    <i className="pi pi-send"></i>Send To Telegram</button>
                            </div>

                        </>)
                        : null}

                </div>


                <Dialog
                    open={dialogBox}
                    onClose={() => {
                        setDialogBox(false);
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div>
                                {ReportError ? (
                                    <span>
                                        <i className="pi pi-exclamation-circle" style={{ color: "#FF6060" }}></i><br />
                                        Fail To Save Report.
                                    </span>
                                ) : null}

                                {ReportSuccess ? (
                                    <span>
                                        <i className="pi pi-check-circle" style={{ color: "#32B18B" }}></i><br />
                                        Report Successfully Saved.
                                    </span>
                                ) : null}

                                {ReportAlreadySuccess ? (
                                    <span>
                                        <i className="pi pi-check-circle" style={{ color: "#32B18B" }}></i><br />
                                        Report Already Saved. To Create New Report Please Refresh The Page Or Send Created Report to Telegram
                                    </span>
                                ) : null}

                                {showError ? (
                                    <span>
                                        <i className="pi pi-check-circle" style={{ color: "#32B18B" }}></i><br />
                                       {errormessage}
                                    </span>
                                ) : null}



                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>




            </div>


        </>
    );
});

export default Report;
